import React from 'react';
import { Icon } from 'antd';
import { Text1, Text5 } from '../../../styles';


const ContactInfo = (props) => {
    const { contact } = props;

    return (
        <div className="contact-info-wrapper">
            <div className="mb-1">
                <Text1 strong>
                    {props.contact.name || "--"}
                </Text1>
            </div>
            <div className="d-table">
                <div className="d-table-row">
                    <div className="d-table-cell">
                        <Text5 type="secondary" className="ml-1"><Icon type="mail" /> {contact.email || "--"}</Text5>
                    </div>
                </div>
                <div className="d-table-row">
                    <div className="d-table-cell">
                        <Text5 type="secondary" className="ml-1"><Icon type="phone" /> {contact.phone || "--"}</Text5>
                    </div>
                </div>
            </div>
        </div>
    )
};

export { ContactInfo };